"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_native_1 = require("react-native");
const Header_1 = __importDefault(require("./Header"));
const map_1 = require("./map");
const timer_1 = require("./timer");
const base_1 = require("@rneui/base");
const App = () => {
    return (react_1.default.createElement(react_native_safe_area_context_1.SafeAreaView, { style: styles.container },
        react_1.default.createElement(react_native_1.ImageBackground, { source: { uri: require('./img/photo2.jpg') }, style: styles.first },
            react_1.default.createElement(Header_1.default, null),
            react_1.default.createElement(timer_1.Timer, null)),
        react_1.default.createElement(react_native_1.ImageBackground, { source: { uri: require('./img/photo10.jpg') }, style: styles.second },
            react_1.default.createElement(react_native_1.View, { style: styles.secondContainer },
                react_1.default.createElement(base_1.Text, { style: styles.text }, "\u0414\u043E\u0440\u043E\u0433\u0438\u0435 \u0433\u043E\u0441\u0442\u0438!"),
                react_1.default.createElement(base_1.Text, { style: styles.textSecond },
                    "07.06.2022",
                    '\n',
                    react_1.default.createElement(base_1.Text, { style: { fontWeight: 'bold', fontFamily: 'Cursive' } }, "\u041A\u0438\u0440\u0438\u043B\u043B \u0438 \u0410\u043D\u043D\u0430"),
                    '\n',
                    react_1.default.createElement(base_1.Text, { style: { fontStyle: 'italic', fontFamily: 'Cursive' } },
                        "\u0441\u043A\u0430\u0436\u0443\u0442 \u0432\u0430\u0436\u043D\u044B\u0435 \u0441\u043B\u043E\u0432\u0430 \u0432\u00A0\u043E\u043A\u0440\u0443\u0436\u0435\u043D\u0438\u0438 \u0440\u043E\u0434\u043D\u044B\u0445 \u0438 \u0431\u043B\u0438\u0437\u043A\u0438\u0445 ",
                        '\n',
                        "\u0421\u0431\u043E\u0440 \u0433\u043E\u0441\u0442\u0435\u0439 \u0432 16:00")))),
        react_1.default.createElement(react_native_1.ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false },
            react_1.default.createElement(react_native_1.Image, { source: { uri: require('./img/photo7.jpg'), width: 800, height: 800 } }),
            react_1.default.createElement(react_native_1.Image, { source: { uri: require('./img/photo.jpg'), width: 800, height: 800 } }),
            react_1.default.createElement(react_native_1.Image, { source: { uri: require('./img/photo1.jpg'), width: 800, height: 800 } }),
            react_1.default.createElement(react_native_1.Image, { source: { uri: require('./img/photo4.jpg'), width: 800, height: 800 } }),
            react_1.default.createElement(react_native_1.Image, { source: { uri: require('./img/photo5.jpg'), width: 800, height: 800 } }),
            react_1.default.createElement(react_native_1.Image, { source: { uri: require('./img/photo8.jpg'), width: 800, height: 800 } })),
        react_1.default.createElement(react_native_1.ImageBackground, { source: { uri: require('./img/photo11.jpg'), width: 600, height: 600 } },
            react_1.default.createElement(map_1.Map, null))));
};
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
    },
    first: {
        minHeight: 800,
    },
    second: {
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 800,
        flex: 1,
        flexWrap: 'wrap',
    },
    secondContainer: {
        flex: 1,
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
    },
    text: {
        fontSize: 40,
        fontFamily: 'Cursive',
    },
    textSecond: {
        fontSize: 30,
    },
});
exports.default = App;
